export default "__VITE_ASSET__CW03ERcN__"